import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Row, Col, Container } from 'react-bootstrap'

// Imports de imágenes
import img10 from '../Rehabilitacion/img10.jpg'
import img12 from '../Rehabilitacion/img12.jpg'
import img33 from '../Rehabilitacion/img33.jpg'
import img34 from '../Rehabilitacion/img34.jpg'
import img36 from '../Rehabilitacion/img36.jpg'
import img35 from '../Rehabilitacion/img35.jpg'
import img37 from '../Rehabilitacion/img37.jpg'
import img64 from '../EquipoMedico/img64.jpg'
import img69 from '../EquipoMedico/img69.jpg'

export class Bedridden extends Component {
    render() {
        const items = [
            { img: img33 }, { img: img36 }, { img: img34 },
            { img: img37 }, { img: img35 }, { img: img64 },
            { img: img10 }, { img: img12 }, { img: img69 }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Bedridden Care</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Estándar de 2 columnas (lg={6}) para maximizar la legibilidad del texto en las imágenes */}
                    <Row className="justify-content-center g-4">
                        {items.map((item, idx) => (
                            <Col key={idx} xs={12} lg={6}>
                                <Card className="shadow-sm border-0 h-100">
                                    <Card.Body className="p-3">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ 
                                                width: '100%', 
                                                height: 'auto', 
                                                objectFit: 'contain' 
                                            }} 
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}